module.exports = __webpack_public_path__ + "a877951862ba77ad974775646c0b22be.svg";